import { bindActionCreators, compose } from 'redux';
import { BorderBox, FullScreenHeader, P } from '@ahmdigital/ui';
import { connect } from 'react-redux';
import { isArray, map, once, size } from 'lodash/fp';
import getIncomeTypeFromScale from '@ahmdigital/logic/lib/utils/get-income-type-from-scale';
import React, { PureComponent } from 'react';

import { RootState } from '../../../reducers';
import AllProductsDataLoader from '../../../components/all-products-data-loader';
import analytics from '../../../analytics';
import CalculatorSection from './components/calculator-section';
import constants from '../../../ahm-constants';
import CustomerActions from '../../../actions/customer';
import enableTaxReminder from './components/calculator-section/utils/enable-tax-reminder';
import filterHospitalServices from './utils/filter-hospital-services';
import getRecommendedProductIds from './utils/get-recommended-product-ids';
import Head from '../../../../utils/head';
import LegacyBorderedWrapper from '../../../components/legacy-bordered-wrapper';
import loadPriceForComponentProps from '../../../models/price/load-price-for-component-props';
import OtherSavings from './components/other-savings';
import PremiumReviewToggle from '../../../components/premium-review-toggle-wrapper';
import prepareProductForProductTile from '../../../utils/prepare-product-for-product-tile';
import PriceActions from '../../../actions/price';
import PricingDrawer from '../../../components/pricing-drawer';
import ProductActions from '../../../actions/product';
import ProductService from '../../../models/product';
import ProductsSection from './components/products-section';
import selectCustomer from '../../../selectors/select-customer';
import styles from './styles.module.sass';

const FREQUENCY = constants.PAYMENT_FREQUENCY.YEARLY;

const trackCalculatorAnalyticOnce = once(() => {
  analytics.publish('action', {
    action: 'Interacted',
    component: 'TaxCalculator',
    label: 'Calculator',
  });
});

type TaxTimeProps = {
  actions: {
    customer?: {
      changeFrequency: (...args: unknown[]) => unknown;
      changeHospitalExcess: (...args: unknown[]) => unknown;
      changeIncome: (...args: unknown[]) => unknown;
      changeIncomeTier: (...args: unknown[]) => unknown;
      changeScale: (...args: unknown[]) => unknown;
      changeState: (...args: unknown[]) => unknown;
    };
    price: {
      load: (...args: unknown[]) => unknown;
    };
    product?: {
      load: (...args: unknown[]) => unknown;
    };
  };
  customer: {
    scale?: string;
    state?: string;
  };
  isLoadingPrice?: boolean;
  prices: {};
  products?: {};
  useFutureEffectiveDate: boolean;
};

class TaxTime extends PureComponent<TaxTimeProps> {
  // @ts-expect-error - Automatic, Please fix when editing this file
  state = {
    mlsAmount: undefined,
  };

  /* eslint-disable-next-line react/sort-comp */
  // @ts-expect-error - Automatic, Please fix when editing this file
  UNSAFE_componentWillMount() {
    const { actions, customer } = this.props;
    if (!customer.state) {
      // @ts-expect-error - Automatic, Please fix when editing this file
      actions.customer.changeState();
    }
  }

  // @ts-expect-error - Automatic, Please fix when editing this file
  componentDidMount() {
    const { actions } = this.props;

    // @ts-expect-error - Automatic, Please fix when editing this file
    actions.customer.changeFrequency(FREQUENCY);
    // @ts-expect-error - Automatic, Please fix when editing this file
    actions.customer.changeHospitalExcess('750');
    // @ts-expect-error - Automatic, Please fix when editing this file
    actions.customer.changeIncome(null);
    // @ts-expect-error - Automatic, Please fix when editing this file
    actions.customer.changeIncomeTier(constants.INCOME_TIER.TIER_0);
    // @ts-expect-error - Automatic, Please fix when editing this file
    loadPriceForComponentProps.componentDidMount(this.props);
  }

  // @ts-expect-error - Automatic, Please fix when editing this file
  componentDidUpdate(prevProps) {
    loadPriceForComponentProps.componentWillReceiveProps(prevProps, this.props);
  }

  // @ts-expect-error - Automatic, Please fix when editing this file
  calculatorChangeHandler = (values) => {
    const { actions } = this.props;
    const { incomeTier } = values;
    // @ts-expect-error - Automatic, Please fix when editing this file
    const { incomeTier: currentIncome } = this.state;

    if (incomeTier !== currentIncome) {
      // @ts-expect-error - Automatic, Please fix when editing this file
      actions.customer.changeIncomeTier(incomeTier);
    }

    this.setState(values);

    trackCalculatorAnalyticOnce();
  };

  // @ts-expect-error - Automatic, Please fix when editing this file
  render() {
    const { actions, customer, isLoadingPrice, products, prices, useFutureEffectiveDate } = this.props;
    const { mlsAmount } = this.state;

    // @ts-expect-error - Automatic, Please fix when editing this file
    const getFilteredProducts = (allProducts) => {
      if (size(allProducts) < 3) {
        return null;
      }
      // @ts-expect-error - Automatic, Please fix when editing this file
      const recommendedProductIds = getRecommendedProductIds(customer, products);
      const recommendedProducts = ProductService.getProducts(allProducts, recommendedProductIds);
      const preparedProducts = map(
        prepareProductForProductTile({
          customer,
          frequency: FREQUENCY,
          mlsAmount,
          prices,
          useFutureEffectiveDate,
        }),
      )(recommendedProducts);
      return filterHospitalServices(preparedProducts);
    };

    const incomeType = getIncomeTypeFromScale(customer.scale);
    const filteredProducts = getFilteredProducts(products);

    const showTaxReminder = enableTaxReminder();
    const currentYear = new Date().getFullYear();

    return (
      <LegacyBorderedWrapper>
        <Head>
          <title>Tax &amp; hospital cover | Medicare Levy Surcharge</title>
          <meta
            name="description"
            content="Learn about whether private health insurance or the Medicare Levy Surcharge could affect your tax. Read more."
          />
        </Head>
        <FullScreenHeader
          title={<>Tax &amp; hospital cover</>}
          subtitle={
            <>
              {showTaxReminder && (
                <P>
                  Heads up, the income thresholds used to calculate the Medicare Levy Surcharge are changing from 1 July{' '}
                  {currentYear}. Read more about the changes below.
                </P>
              )}
              <P>
                The Medicare Levy Surcharge (MLS) could be costing you extra in tax. ahm has hospital cover options that
                could help you save on the surcharge. Find out if the surcharge applies to you.
              </P>
            </>
          }
          scrollToElementId="calculator"
          scrollToElementText="The ins and outs of tax &amp; hospital cover"
        />
        <div id="calculator">
          {isArray(filteredProducts) && (
            <BorderBox
              variant={['paddingTopSpacer3', 'paddingBottomSpacer3', 'thin', styles.withDollarSignsBackground]}
            >
              <CalculatorSection
                customer={customer}
                incomeType={incomeType}
                mlsAmount={mlsAmount}
                onChange={this.calculatorChangeHandler}
                // @ts-expect-error - Automatic, Please fix when editing this file
                onIncomeChange={actions.customer.changeIncome}
                // @ts-expect-error - Automatic, Please fix when editing this file
                onScaleChange={actions.customer.changeScale}
                // @ts-expect-error - Automatic, Please fix when editing this file
                onStateChange={actions.customer.changeState}
              />
              {/* @ts-expect-error - Automatic, Please fix when editing this file */}
              <PremiumReviewToggle type="alternativePage" hasEvenSpacing />
              {/* @ts-expect-error - Automatic, Please fix when editing this file */}
              <ProductsSection mlsAmount={mlsAmount} products={filteredProducts} isLoadingPrice={isLoadingPrice} />
            </BorderBox>
          )}
        </div>
        <OtherSavings />
        <PricingDrawer
          // @ts-expect-error - Automatic, Please fix when editing this file
          useFutureEffectiveDate={useFutureEffectiveDate}
          isProductWithHospitalServices
          showIncomeOptions={false}
        />
      </LegacyBorderedWrapper>
    );
  }
}

// @ts-expect-error - Automatic, Please fix when editing this file
TaxTime.defaultProps = {
  isLoadingPrice: false,
  products: null,
};

const mapStateToProps = (state: RootState) => ({
  customer: selectCustomer(state),
  isLoadingPrice: state.price.loading,
  prices: state.price.data,
  products: state.product.data,
  useFutureEffectiveDate: state.price.useFutureEffectiveDate,
});

// @ts-expect-error - Automatic, Please fix when editing this file
const mapDispatchToProps = (dispatch) => ({
  actions: {
    customer: bindActionCreators(CustomerActions, dispatch),
    price: bindActionCreators(PriceActions, dispatch),
    product: bindActionCreators(ProductActions, dispatch),
  },
});

export default compose(AllProductsDataLoader, connect(mapStateToProps, mapDispatchToProps))(TaxTime);

export { TaxTime as TaxTimeForTest, mapStateToProps };
